module.exports = __webpack_public_path__ + "static/media/voicemail.157c9600.svg";